import { Link } from "react-router-dom";
import { LegalDoc, Section, Bullets } from "@/components/LegalDoc";
import { useSeo } from "@/lib/seo";

export default function Privacy() {
  useSeo({
    title: "Privacy Policy — StayGuide",
    description: "Come StayGuide (Urban View Srl) tratta i dati personali di host e ospiti, in conformità al GDPR.",
    path: "/privacy",
  });
  return (
    <LegalDoc
      title="Privacy Policy"
      updated="Giugno 2026"
      intro="La presente informativa descrive come StayGuide tratta i dati personali degli host e degli ospiti, in conformità al Regolamento (UE) 2016/679 (GDPR) e alla normativa italiana applicabile.">
      <Section n="1" title="Titolare del trattamento">
        <p>Il titolare del trattamento è <strong>Urban View Srl</strong>, con sede in <strong>Via Monti Sabini 24, 20141 Milano</strong>, P.IVA <strong>03533690123</strong>.</p>
        <p>Per qualsiasi richiesta relativa alla privacy puoi scrivere a <a href="mailto:privacy@stayguide.it" className="text-blue-600 font-semibold">privacy@stayguide.it</a>.</p>
      </Section>
      <Section n="2" title="Dati che raccogliamo">
        <Bullets items={[
          "Dati dell'account host: nome, indirizzo email, password (conservata cifrata), preferenze e paese.",
          "Dati delle strutture e delle guide: informazioni che inserisci (indirizzo, Wi-Fi, regole, consigli, contatti, immagini).",
          "Dati di pagamento: gestiti direttamente da Stripe; non conserviamo i dati completi della carta.",
          "Dati di utilizzo: statistiche di visualizzazione delle guide e dati tecnici (log, dispositivo, indirizzo IP) per sicurezza e funzionamento.",
          "Interazioni con il Concierge AI: le domande poste dagli ospiti per generare le risposte.",
        ]} />
      </Section>
      <Section n="3" title="Finalità e basi giuridiche">
        <Bullets items={[
          "Erogazione del servizio (creazione e pubblicazione delle guide) — esecuzione del contratto (art. 6.1.b GDPR).",
          "Fatturazione e adempimenti fiscali — obbligo legale (art. 6.1.c GDPR).",
          "Sicurezza, prevenzione abusi e miglioramento del servizio — legittimo interesse (art. 6.1.f GDPR).",
          "Comunicazioni di servizio e, se acconsenti, comunicazioni promozionali — consenso (art. 6.1.a GDPR).",
        ]} />
      </Section>
      <Section n="4" title="Concierge AI">
        <p>I contenuti della tua guida e le domande degli ospiti vengono elaborati dai nostri fornitori di intelligenza artificiale al solo scopo di generare risposte pertinenti. Le risposte si basano esclusivamente sulle informazioni della guida. I dati non vengono utilizzati per addestrare modelli di terze parti.</p>
      </Section>
      <Section n="5" title="Fornitori terzi (responsabili del trattamento)">
        <p>Per erogare il servizio ci avvaliamo di fornitori affidabili che trattano i dati per nostro conto:</p>
        <Bullets items={[
          "Stripe — elaborazione dei pagamenti.",
          "Resend — invio delle email transazionali (benvenuto, reset password, conferme).",
          "Fornitori di modelli AI (es. OpenAI, tramite piattaforma Emergent) — generazione dei contenuti e Concierge AI.",
          "Google — accesso con account Google (login) e collegamenti a Google Maps.",
          "OpenStreetMap — visualizzazione delle mappe nelle guide.",
        ]} />
      </Section>
      <Section n="6" title="Conservazione dei dati">
        <p>Conserviamo i dati per il tempo necessario a fornire il servizio e ad adempiere agli obblighi di legge. Alla cessazione dell'account, i dati vengono cancellati o resi anonimi entro un termine ragionevole, salvo obblighi di conservazione (es. fatturazione).</p>
      </Section>
      <Section n="7" title="Trasferimenti extra-UE">
        <p>Alcuni fornitori possono trattare i dati al di fuori dell'Unione Europea. In tali casi garantiamo adeguate garanzie (es. Clausole Contrattuali Standard) come previsto dal GDPR.</p>
      </Section>
      <Section n="8" title="I tuoi diritti">
        <p>In qualità di interessato puoi esercitare in ogni momento i diritti previsti dagli artt. 15-22 GDPR:</p>
        <Bullets items={[
          "Accesso, rettifica e cancellazione dei tuoi dati.",
          "Limitazione e opposizione al trattamento.",
          "Portabilità dei dati.",
          "Revoca del consenso in qualsiasi momento (senza pregiudicare i trattamenti già svolti).",
          "Reclamo all'Autorità Garante per la protezione dei dati personali.",
        ]} />
        <p>Per esercitare i tuoi diritti scrivi a <a href="mailto:privacy@stayguide.it" className="text-blue-600 font-semibold">privacy@stayguide.it</a>.</p>
      </Section>
      <Section n="9" title="Sicurezza">
        <p>Adottiamo misure tecniche e organizzative adeguate (cifratura delle password, connessioni sicure, controlli di accesso) per proteggere i dati da accessi non autorizzati, perdita o divulgazione.</p>
      </Section>
      <Section n="10" title="Modifiche">
        <p>Potremmo aggiornare questa informativa. In caso di modifiche sostanziali ne daremo comunicazione. Ti invitiamo a consultare periodicamente questa pagina.</p>
      </Section>
      <Section n="11" title="Contatti">
        <p>Per qualsiasi domanda su questa informativa contatta <strong>Urban View Srl</strong> all'indirizzo <a href="mailto:privacy@stayguide.it" className="text-blue-600 font-semibold">privacy@stayguide.it</a>. Consulta anche la nostra <Link to="/cookie" className="text-blue-600 font-semibold">Cookie Policy</Link> e i <Link to="/termini" className="text-blue-600 font-semibold">Termini di Servizio</Link>.</p>
      </Section>
    </LegalDoc>
  );
}
